import { SCREEN } from "helper/roleChecker/Screens";
import { lazy } from "react";

import pathRoutes from "routes/pathRoutes";
const MainPage = lazy(() => import("./Pages/Main"));

export const operationProcessRoutes = [
  {
    page: MainPage,
    path: pathRoutes.operationProcess,
    screenCode: SCREEN.IP_010,
  },
];
